import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'hr',
    fullName: 'Croatian',
    nativeName: 'Hrvatski',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Dolazi nešto nevjerojatno",
    landing_subtitle: "ArgVoid je studio za razvoj aplikacija i igara. Pratite nas, nove stvari stižu uskoro!",
    select_language: "Odaberite jezik",
    search_placeholder: "Traži jezike...",
    terms_title: "Uvjeti usluge",
    policy_title: "Politika privatnosti",
    cookies_title: "Politika kolačića",
    terms_content: `
        <strong>1. Prihvaćanje uvjeta </strong><br>
        Pristupom ArgVoid-u prihvaćaju se ovi Uvjeti pružanja usluge. Ako ovi uvjeti nisu suglasni, usluga se ne bi trebala koristiti.<br><br>

        <strong>2. Korištenje platforme</strong><br>
        ArgVoid i njegove aplikacije pružaju se "kakve jesu" u informativne i kreativne svrhe. Usluga se mora koristiti samo u zakonite svrhe.<br><br>

        <strong>3. Zabranjeno ponašanje</strong><br>
        Iskorištavanje ranjivosti stranice, slanje neželjene pošte ili pokušaj neovlaštenog pristupa infrastrukturi strogo je zabranjeno.<br><br>

        <strong>4. Odricanje od odgovornosti</strong><br>
        Platforma i usluge mogu se izmijeniti u bilo kojem trenutku bez prethodne najave. Nema jamstva u pogledu neprekidnog rada ili dostupnosti usluge.
    `,
    policy_content: `
        <strong>1. Zbirka informacija</strong><br>
        Platforma trenutno ne zahtijeva autentifikaciju korisnika niti stvaranje računa. Od posjetitelja se aktivno ne prikupljaju nikakvi podaci za identifikaciju osobe (kao što su imena ili adrese e-pošte).<br><br>

        <strong>2. Podaci o korištenju</strong><br>
        Osnovna, anonimizirana analitika može se prikupiti kako bi se razumio promet stranice i poboljšale aplikacije. Ovi podaci nisu povezani s pojedinačnim korisničkim identitetima.<br><br>

        <strong>3. Usluge trećih strana </strong><br>
        Davatelji trećih strana mogu se koristiti za hosting i usluge analitike. Prakse privatnosti ovih odgovarajućih pružatelja upravljaju anonimnim podacima koji se obrađuju na njihovoj infrastrukturi. <br><br>

        <strong>4. Sigurnost podataka</strong><br>
        Za zaštitu platforme provode se razumne sigurnosne mjere. Međutim, nijedna metoda prijenosa putem interneta nije potpuno sigurna.<br><br>
    `,
    cookies_content: `
        <strong>1. Što su kolačići i lokalna pohrana? </strong><br>
        Kolačići i lokalna pohrana preglednika male su podatkovne datoteke pohranjene na uređaju radi pamćenja konfiguracijskih postavki tijekom posjeta.<br><br>

        <strong>2. Svrha upotrebe</strong><br>
        Browser LocalStorage koristi se isključivo za spremanje konfiguracijskih postavki, kao što su: <br>
        - Jezične postavke<br>
        - Konfiguracija korisničkog sučelja (npr. postavke izgleda ili teme) <br>
        - Privremena predmemorija aplikacije<br><br>

        <strong>3. Nema praćenja</strong><br>
        Kolačići i lokalna pohrana ne koriste se u svrhe oglašavanja ili praćenja trećih strana. Svi pohranjeni podaci isključivo su za temeljnu funkcionalnost platforme.<br><br>

        <strong>4. Kontrola</strong><br>
        Podaci preglednika mogu se obrisati u bilo kojem trenutku putem postavki preglednika, što će poništiti sve lokalne konfiguracije.
    `,
    cookie_consent_text: "Koristimo osnovne kolačiće kako bismo osigurali ispravno funkcioniranje web stranice, kao što je održavanje vaše sesije aktivnom, spremanje vaših preferencija jezika i druge prilagođene konfiguracije.",
    read_policy: "Pročitajte Pravila o kolačićima",
    support_title: "Obratite se podršci",
    support_subject_label: "Predmet",
    support_message_label: "Poruka",
    support_submit_button: "Pošalji poruku",
    support_hint: "Napomena: Ovo će otvoriti vašu zadanu aplikaciju e-pošte za slanje poruke.",
    support_success_msg: "Otvaranje aplikacije za e-poštu...",
    support_error_msg: "Slanje poruke nije uspjelo. Pokušajte ponovno kasnije.",
    explorer_title: "Istraživač",
    history_title: "Povijest",
    animation_title: "Animacija",
    config_title: "Konfiguracija",
    tool_mouse: "Odaberite (Ctrl+M)",
    tool_brush: "Kist (Ctrl+B)",
    tool_brush_mode: "Promjena načina rada (puno/jasno)",
    tool_eraser: "Gumica (Ctrl+E)",
    tool_brush_size: "Podesite veličinu četke",
    tool_bucket: "Ispuna (Ctrl+F)",
    tool_eyedropper: "Kapaljka za oči",
    tool_grid: "Rešetka (Ctrl+Shift+B)",
    tool_rotate: "Zakreni (Ctrl+Shift+R)",
    tool_flip_h: "Okreni H (Ctrl+Shift+H)",
    tool_flip_v: "Okreni V (Ctrl+Shift+V)",
    tool_transpose: "Transponiranje (Ctrl+Shift+T)",
    label_width: "Širina",
    label_height: "Visina",
    label_frames: "Broj okvira",
    label_animation: "Stil animacije",
    label_background_color: "Boja pozadine",
    label_interval: "Interval",
    tool_anim_config: "Konfiguracija animacije",
    label_new_width: "Nova širina",
    label_new_height: "Nova visina",
    label_apply: "primijeniti",
    label_colors: "Boje",
    label_size: "Veličina",
    label_tolerance: "Tolerancija",
    val_horizontal: "Horizontalno",
    val_vertical: "Okomito",
    val_sequence: "Slijed",
    val_bounce: "Odskakivati",
    val_random: "Slučajno",
    val_solid: "Čvrsto",
    val_clear: "Jasan",
    action_add_sheet: "Novi list",
    action_import: "Uvoz",
    action_export: "Izvoz",
    action_sort_projects: "Vrsta",
    sort_date_old: "Prvo najstariji",
    sort_date_new: "Prvo najnovije",
    sort_name_az: "Ime (A-Z)",
    sort_name_za: "Ime (Z-A)",
    action_new_sprite: "Novi Sprite",
    action_new_project: "Novi projekt",
    modal_save_all_title: "Spremi sve promjene",
    modal_save_all_desc: "Odaberite sredstva za spremanje:",
    modal_save_selected: "Spremi odabrano",
    action_saved: "Spremljeno",
    modal_create_sprite_title: "Stvori novi Sprite",
    modal_create_project_title: "Stvori novi projekt",
    modal_add_sheet_title: "Dodaj novi list",
    modal_rename_sheet_title: "Preimenuj list",
    modal_rename_sprite_title: "Preimenuj Sprite",
    modal_delete_sprite_title: "Izbriši Sprite",
    modal_delete_project_title: "Izbriši projekt",
    modal_delete_sheet_title: "Izbriši list",
    placeholder_sprite_name: "Ime",
    placeholder_project_name: "Ime",
    placeholder_sheet_name: "Ime",
    placeholder_new_name: "Novo ime",
    action_create: "Stvoriti",
    action_add: "Dodati",
    action_rename: "Preimenovati",
    action_duplicate: "Duplikat",
    action_delete: "Izbrisati",
    action_cancel: "Otkazati",
    confirm_delete_sprite: "Jeste li sigurni da želite izbrisati ovaj duh?",
    confirm_delete_project: "Jeste li sigurni da želite izbrisati ovaj projekt? Svi spriteovi će biti uklonjeni.",
    confirm_delete_sheet: "Jeste li sigurni da želite izbrisati ovaj list?",
    err_select_sprite: "Prvo odaberite sprite.",
    err_select_project: "Prvo odaberite projekt.",
    err_name_empty: "Ime ne može biti prazno.",
    err_sprite_exists: "Sprite s tim nazivom već postoji.",
    err_project_exists: "Projekt s tim imenom već postoji.",
    err_no_content: "Nema sadržaja za spremanje.",
    err_no_changes: "Nema promjena za spremanje.",
    err_delete_last_sheet: "Nije moguće izbrisati zadnji list.",
    err_extract_frames: "Nije moguće izdvojiti nijedan okvir.",
    err_indexeddb: "Lokalno spremanje nije uspjelo. Vaš preglednik možda ne podržava IndexedDB.",
    msg_upload_success: "Učitavanje uspješno: {0}",
    msg_upload_failed: "Prijenos nije uspio: {0}",
    msg_save_success: "Spremanje uspješno.",
    msg_saving: "Spremanje...",
    msg_multi_save_result: "Spremljeno {0} sredstava. {1} neuspjeha.",
    menu_title: "Jelovnik ",
    menu_save: "Uštedjeti",
    menu_save_all: "Spremi sve",
    menu_support: "Obratite se podršci",
    label_local_storage: "Lokalna pohrana",
    label_sign_in: "Prijavite se",
    modal_export_title: "Izvoz Sprite",
    label_filename: "Naziv datoteke",
    label_format: "Format",
    action_export_confirm: "Izvoz",
};

export default translations;
